export default {
  line: "خط",
  language: "لغة",
  common: [
    "الخدمات عبر الإنترنت",
    "إلغاء التعليق",
    "هل يجب إنفاق 10000 USDT لإتمام عملية الشراء؟!"
  ],
  informationHub: "المركز الرسمي لـ SGM.s",
  upload: [
    "جاري التحميل...",
    "تنسيق خاطئ",
    "تم التحميل بنجاح",
    "فشل التحميل"
  ],
  vanPull: [
    "لا مزيد من البيانات",
    "لا توجد بيانات"
  ],
  login: {
    title:'تسجيل الدخول باستخدام اسم المستخدم وكلمة المرور',
    title_txt:'قم بتسجيل الدخول باستخدام رقم هاتفك المحمول المسجل',
    text: [
      "تذكر اسم المستخدم/كلمة المرور",
      "التسجيل...",
      "تسجيل الدخول الآن"
    ],
    placeholder: [
      "الرجاء إدخال رقم الهاتف",
      "الرجاء إدخال كلمة المرور لتسجيل الدخول"
    ],
    i18n: [
      "لا يوجد حساب {title}؟ {a} {line}",
      "يسجل"
    ]
  },
  register: {
    text: [
      "مرحبا بكم في التسجيل",
      "إرسال رمز الرسائل القصيرة...",
      "احصل على رمز الرسالة النصية القصيرة",
      "التسجيل...",
      "سجل الآن",
      "هل لديك حساب بالفعل؟ تسجيل الدخول الآن",
      "تسجيل رقم الهاتف المحمول",
      "تسجيل البريد الإلكتروني",
	    "العودة إلى تسجيل الدخول",
      "يرجى استخدام رقم هاتف وعنوان بريد إلكتروني غير مسجلين"
    ],
    placeholder: [
      "الرجاء إدخال رقم هاتفك",
      "الرجاء إدخال رمز التحقق من الرسائل القصيرة",
      "الرجاء إدخال كلمة المرور لتسجيل الدخول",
      "الرجاء تأكيد كلمة المرور الخاصة بك",
      "الرجاء إدخال رمز الدعوة",
      "كلمتي المرور مختلفتان",
      "الرجاء إدخال رمز التحقق",
      "الرجاء إدخال رقم البريد الإلكتروني",
	    "لا يمكن البدء بـ 0"
    ],
    i18n: [
      "هل لديك حساب؟ {a} {line}",
      "تسجيل الدخول"
    ]
  },
  home: {
    lucky: "الحدث لم يفتح بعد",
    map: "موقع",
    qywh: "ثقافة الشركات",
    broadcast: "تهانينا لشريكنا: {member} أوصى {vipname} بالانضمام وحصل على مكافأة الترويج {grade} {currency}!",
    menu: [
      "منطقة كبار الشخصيات",
      "فيديو تعليمي",
      "مكافآت الترويج"
    ],
    taskHall: {
      title: [
        "قاعة المهام",
        "قاعة الأعمال",
        "أكمل المهام لتحقيق الأرباح"
      ]
    },
    title:['مهمة','أخبار','more','أكثر','يرجى إلغاء القفل ومواصلة الاستخدام~','الدفع','مبروك! تم الترقية بنجاح','مبروك ~ حصلت على بطاقتين'],
    memberList: {
      title: "قائمة العضوية",
      data: [
        "{member},أكمل مهام الطلب {num} لهذا اليوم!"
      ]
    },
    businessList: {
      title: "قائمة التجار",
      data: [
        "{member}",
        "إصدار {num} مهمة واحدة اليوم"
      ]
    },
    noticeTitle: ["إشعار","السابق","التالي"],
    tabBar: ["الرئيسية","الفريق","T","الخريطة","خاصتي"],
    msg: "المهمة ليست مفتوحة",
    video: "لا يوجد فيديو تعليمي",
	  message: "لديك اخبار جديدة",
	  bonus:[
		'<p>أدخل كلمة المرور للحصول على مكافأة نقدية على شكل مظروف أحمر.</p><p>1. يتم الحصول على كلمة المرور من خلال أنشطة الشركة!</p><p>٢. تُصدر مجموعة العمل كلمات مرور من حين لآخر! يُمكنك الاطلاع على معلومات مجموعة العمل يوميًا!</p><p>للحصول على التفاصيل، يرجى استشارة "مدير التوظيف""</p>',
		'يتم الحصول على كلمة المرور من خلال أنشطة الشركة!',
		'أدخل رمز الظرف الأحمر',
		'استلام الظرف الأحمر',
		'مبروك حصولك على مكافأة الظرف الأحمر {amount}'
	],
    helpCenter: {
      title: "Help Center",
      empty: "No help articles"
    }
  },
  vip: {
    title:[
      "مستوى VIP",
      "انضم إلى العضوية الآن للمطالبة بالمهام"
    ],
    user: {
      title: [
        "هويتك",
        "الزوار"
      ],
      label: "المهام اليومية",
      value: [
        "تاريخ السريان",
        "سنة واحدة",
        "الرجاء تسجيل الدخول أولاً",
        "مدة صلاحية التدريب",
        "العد التنازلي لإرجاع الوديعة",
        "العد التنازلي لصلاحية مستوى LP"
      ],
    },
    list: {
      label: "المهام اليومية:{number}",
      button: "انضم الآن",
      text: [
        "الربح اليومي",
        "الدخل الشهري",
        "مكافأة التوظيف: الجميع",
        "حر",
        "حسب الطلب",
        "دخل التصنيف",
        "عوائد فعالة",
        "تاريخ انتهاء الصلاحية",
        "سنة",
        "يوم",
        "فترة الصلاحية"
      ],
    },
    dialog: [
      "هل أنت متأكد من إنفاق {currency} {amount} لتصبح {name}؟",
      "أنت حاليًا {currname} ولا يمكنك أن تكون {name}",
      "هل أنت متأكد من إنفاق {currency} {amount} لتجديد {name}؟",
    ],
    index: ["إلغاء","تأكيد"],
    desc: [
      '{level} فوائد',
      'الدخل الأساسي',
      'وقت',
      'عدد المهام',
      'دخل',
      'يوميًا',
      'شهريا',
      'سنوي',
      'دخل التوظيف',//8
      'المستوى التابع',
      'نسبة عمولة التوظيف',
      'مكافأة التوظيف',
      'مرؤوس المستوى 1',
      "مرؤوس المستوى 2",
      "مرؤوس المستوى 3",
      'خصم على مهمة يوم واحد',
      'المستوى التابع',
      'نسبة خصم المهام التابعة',//17
      'مبلغ خصم المهمة',
      'مرؤوس المستوى 1',
      'مرؤوس المستوى 2',
      'مرؤوس المستوى 3',
      '3 أيام',
      'سعر وحدة المهمة',
      'تفاصيل فترة الاختبار',//24
      'التدريب: لا يتطلب شراءً. مهمة واحدة يوميًا، بعمولة 1500 دينار عراقي لكل مهمة (1500 دينار يوميًا). مدة فترة التدريب التجريبية يومان فقط.',
      'مثال على مهمة اللجنة:',
      '<p>المستوى الأول: يحصل المرؤوس على عمولة قدرها 300 دينار عراقي عند إكمال طلبات مهام يومية بقيمة إجمالية 10,000 دينار عراقي.</p><p>المستوى الثاني: يحصل المرؤوس على عمولة قدرها 200 دينار عراقي عند إكمال طلبات مهام يومية بقيمة إجمالية 10,000 دينار عراقي.</p><p>المستوى الثالث: يحصل المرؤوس على عمولة قدرها 100 دينار عراقي عند إكمال طلبات مهام يومية بقيمة إجمالية 10,000 دينار عراقي.</p>',
      'وصف مكافأة الإحالة:',
      '<p>(المرؤوس المستوى 1) أنت تدعو أ للانضمام مباشرة، أ هو مرؤوسك المستوى 1.</p><p>(المرؤوس المستوى 2) يدعو أ ب للانضمام، ب هو مرؤوسك المستوى 2.</p><p>(المرؤوس المستوى 3) يدعو B C للانضمام، C هو مرؤوسك من المستوى 3.</p><p>ملاحظة: لا يمكن المطالبة بمكافأة الإحالة إلا لأعلى مكافأة في المستوى الحالي للفرد.</p>',
    ]
  },
  charitable: [
    'منصة SGM العالمية',
    'تعميق تحول التسويق الرقمي، والمساعدة في الامتثال في آسيا الوسطى وبناء الحرية المالية معاً مع فريق عالي الجودة.',
    'الاقتصاد الرقمي للعمل الحر والمصفوفة العالمية للتعهيد الجماعي تدخل عصر الأرباح الهيكلية. في الأسواق الناشئة، وخاصة في آسيا الوسطى (مع طاجيكستان كمنطقة أساسية)، هناك طلب متفجر من شريحة كبيرة من السكان العاملين على التوظيف المتنوع عبر الإنترنت مع حواجز دخول دنيا وعوائد مرتفعة.',
    'من خلال التقنيات الفريدة "استعادة قيمة الشبكة الشخصية" و"توزيع المهام الرقمية"، نحول وقت فراغ كل شخص إلى أصول اقتصادية مستقرة ونساعد عشرات الآلاف من العائلات على تحقيق تحسينات شاملة في ظروف معيشتهم.',
    'نشجعكم على المشاركة بنشاط في المبادرات الخيرية المجتمعية، ومعاً نجعل الحب والخضرة تزدهر في كل ركن من أركان المدينة..',
    'الورقة البيضاء الرسمية للأعمال v2.7.1'
  ],
  lucky: {
  	default:[
  		"السحب المحظوظ",
  		"عدد السحوبات المتبقية:",
  		"سجل اليانصيب",
  		"قواعد اليانصيب",
      "<p>شارك في أنشطة الشركة واحصل على فرص السحب المحظوظ!</p>",
      "سجل المستخدم الفائز",
      ['مبروك:{member}','احصل على جوائز {profit}'],
      "مبروك، احصل على جوائز ",
      "يغلق",
      "لقد تم استنفاد أوقات السحب الخاصة بك",
      "صالحة حتى"
  	],
    scattered:[
      'عدد السحوبات',
      'يبدأ',
      '<p>1.يتم الحصول على عدد السحوبات من خلال أنشطة الشركة!</p><p>2. كل سحب يستهلك سحبًا واحدًا!</p><p>3. بعد الفوز بالجائزة المادية، يرجى الاتصال بمدير التوظيف لتسجيل معلوماتك واستلامها!</p>',
      'تذكير',
    ],
  },
  userLc:{
  	default:[
  	"تعزيز الثروة",
  	"السجلات",
  	"كمية",
  	"فترة التخزين",
  	"مبلغ الإيداع",
  	"الرجاء إدخال مبلغ الإيداع",
  	"ربح",
    "يُقدِّم",//7
    "الرجاء تحديد المنتج أولا",
    "الرجاء تحديد المعلومات",
    "ربح",
    "يوم",
    "لا توجد بيانات",
    "وقت الشراء",
    "ولاية",
    "وقت النهاية",
    "توازن",
    "أرباح اليوم",
    "شراء بنقرة واحدة"//18
  	],
    tabs: [
      "قائمة المنتجات",
      "قائمة المستثمرين"
     ],
    tips:'<p>برنامج "تعزيز الثروة" من VOISP هو وسيلة الشركة لتزويد جميع موظفي المستوى الإداري بمزيد من سبل زيادة دخلهم. مشاريع الاستثمار هي مشاريع استثمار مالي مشتركة بين PAGE والبنوك وشركات إدارة الأصول وغيرها.</p><p>استثمار قصير الأجل: دخل ثابت، واختيار مرن لدورة الاستثمار! الصناديق الخاملة قصيرة الأجل تُدر دخلاً إضافياً من خلال الاستثمار! استثمار طويل الأجل: عوائد أعلى، استثمر بانتظام، وحقق عوائد أعلى، وحقق أحلامك من خلال التراكم!</p>'
  },
  newlist: {
    text: [
     "لا يوجد سجلات",
    "الدخل المتوقع",
    "نتائج",
    "شراء الوقت",
    "حالة",
    "نهاية الزمان"
    ],
    placeholder: [
     "لا مزيد من البيانات",
      "لا توجد بيانات"
    ],
    i18n: [
     "سجل الشراء",
    ]
  },
  product: {
    default: [
      "رصيد حساب الترويج",
      "مبلغ الاستثمار الأولي",
      "الحد الأقصى لمبلغ الاستثمار",
      "دورة",
      "سعر الفائدة اليومي",
      "الحد الأقصى",
      "قواعد المشروع",
      "مبلغ المشروع",
      "طريقة الدفع",
      "مبلغ الاستثمار الأولي",
      "الربح اليومي",
      "دورة الإصدار",
      "الدخل المقدر"
    ],
    investRange: "نطاق مبلغ الاستثمار",
    placeholder: [
      "إرجاع رأس المال والدخل عند الاستحقاق (طبيعي في أيام العطلات)",
      "، تسوية تلقائية خلال 24 ساعة",
      "{str} = إجمالي الدخل {income} {currency} + رئيسي {money} {currency} = إجمالي رأس المال والفائدة {total} {currency}",
      "كلمة مرور الأمان"
    ]
  },
  user: {
    vipl:"مستوى الشريك",
    hello:"مرحبًا بعودتك",
    default: [
      "رئيسي",
      "حساب",
      "رمز الدعوة",
      "الخروج من تسجيل الدخول",
      "توازن",
      "ذهب",
      "محفظتي",
      "ختم",
      "تقييد",
      "جيد",
      "ممتاز",
	    "فعل 'مساعد القراءة'",
	    "الاتصال بمدير التوظيف"
    ],
    myEarnings: {
            grid: [
				"توازن",
			"أرباح الأمس",
			"أرباح اليوم",
			"أرباح هذا الأسبوع",
			"أرباح هذا الشهر",
			"أرباح الشهر الماضي",
			"إجمالي الإيرادات",
			"أكمل المهمة اليوم(PCE)",
			"المهام المتبقية اليوم (PCE)",
			"لجنة اليوم",
			"خصم المهمة",
			"خصم الإحالة"
			]
        },
    grid: [
      "توازن",
      "أرباح الأمس",
      "أرباح اليوم",
      "أرباح هذا الأسبوع",
      "أرباح هذا الشهر",
      "أرباح الشهر الماضي",
      "إجمالي الإيرادات",
      "أكمل المهمة اليوم(PCE)",
      "المهام المتبقية اليوم (PCE)",
      "لجنة اليوم",
      "خصم اليوم"
    ],
    menu: [
      "سجلات المهام",
      "مهمة التدقيق",
      "إدارة الإصدار",
      "معلومات شخصية",//3
      "ربط الحساب",
      "البيان اليومي",
      "السجلات المحاسبية",//6
      "دعوة الأصدقاء",
      "تقارير الفريق",//8
      "دليل المساعدة",//9
      "درجة الائتمان",//10
      "تنزيل التطبيق",//11
	    "السحب المحظوظ",//12
	    "منطقة الاستثمار",
	    "مساعد القراءة",
      "نبذة عن الشركة",
      "فيديو تعليمي",
      "فريق ممتاز",
      "منطقة الاستثمار",
	    "تابع SGM.s	    مكافآت النمو",
	    "الظرف الأحمر",
      "صدقة",
      "شهادة SGM"
    ],
	positions:[
		"موقفي",
      "المنصب الحالي",
      "الموضع التالي",
      "عضو منتسب بشكل مباشر على مستوى M",
      "عضو فريق المستوى 3 م",
      "فريق المستوى 3 (عدد من {post})",
      "استوفي جميع المتطلبات اللازمة للتواصل مع مدير التوظيف لترقية منصبك!",
      "وصف الوظيفة",
			"التقدم للوظيفة",
			"معلومات عن الموقع"
	],
	office:[
		"معلومات عن موقعي",
		"تفاصيل الترقية الوظيفية",
		"وصف وظيفة SGM.s		مناصب الشركة",
		"ترقية وظيفية",
		"أرسل طلبك",
		"تقدم الترويج",
		"على الأقل ",
		"الشروط غير مستوفاة",//8
		"يجب أن يصبح الأعضاء في الفريق المكون من ثلاثة مستويات (أ/ب/ج) ({name}).",
		"يجب أن يكون لدى الفريق أكثر من ",
		" أعضاء",
		"تم الاستلام"//12
	],
	current:[
		"المناصب الحالية",
		"إجمالي الأعضاء"
	],
	subordinate:[
		"المستوى المتقدم",
		"المستوى ب",
		"المستوى C",
		"قائمة الأعضاء",
		"إجمالي الأشخاص",
		"إجمالي الإيرادات",
		"مبلغ السحب",
		"دخل الفريق",
		"قائمة الأعضاء",
		"مستخدم",
		"مستوى",
		"انضم إلى الوقت",
		"فترة تجريبية"
	],
	follow:[
		"القناة الرسمية لـ SGM.s		اتبع القناة لمعرفة المزيد عن أحدث المعلومات حول SGM.s	"]
  },
  userInfo: {
    default: [
      "معلومات شخصية",
      "صورة الرأس",
      "رقم الهاتف المحمول",
      "إضافة حساب بنكي",
      "مبروك",
      "الاسم الحقيقي",
      "كلمة مرور تسجيل الدخول",
      "كلمة مرور الصندوق",
      "انقر فوق الإعدادات",
      "تغيير صورة الرأس",
      "تغيير كلمة المرور لتسجيل الدخول",
      "تغيير كلمة مرور الصندوق",
      "يُقدِّم",
      "إفراغ ذاكرة التخزين المؤقت",
	  "تسجيل الخروج"
    ],
    label: [
      "كلمة المرور الأصلية لتسجيل الدخول",
      "كلمة مرور تسجيل الدخول الجديدة",
      "تأكيد كلمات المرور",
      "رمز المال الأصلي",
      "رمز مالي جديد",
      "تأكيد كلمة المرور"
    ],
    placeholder: [
      "الرجاء إدخال كلمة المرور الأصلية لتسجيل الدخول",
      "الرجاء إدخال كلمة مرور تسجيل الدخول الجديدة",
      "الرجاء تأكيد كلمة المرور لتسجيل الدخول",
      "الرجاء إدخال كلمة المرور الأصلية للصندوق",
      "الرجاء إدخال كلمة المرور الجديدة للأموال",
      "يرجى تأكيد كلمة مرور الصندوق"
    ]
  },
  userSet: {
    default: [
      "شهادة الاسم الحقيقي",
      "معلومات مفصلة",
      "ربط Alipay",
      "يُقدِّم"
    ],
    label: [
      "الاسم الحقيقي",
      "كيو كيو",
      "حساب علي باي",
      "اسم أليباي"
    ],
    placeholder: [
      "الرجاء إدخال اسمك الحقيقي (يتم استخدام اسمي لسحب النقود)",
      "أدخل رقم QQ",
      "الرجاء إدخال حساب Alipay",
      "الرجاء إدخال اسم Alipay"
    ],
    tips: "تذكير: لا يمكن تعديل البطاقة المصرفية المربوطة، ويتم استخدامها للسحب"
  },
  bindAccount: {
    default: [
      "ربط الحساب",
      "مشاهدة البرنامج التعليمي",
      "يُقدِّم"
    ],
    tabs: [
      "حساب",
      "حساب",
      "حساب"
    ],
    label: [
      "تعليمات",
      "إضافة لقطة شاشة",
      "حساب"
    ],
    placeholder: "الرجاء إدخال حسابك {account}"
  },
  bankCard: {
    default: [
      "ربط بطاقة البنك",
      "قم بالمصادقة الآن",
      "تقديم ...",
      "أضف الآن",
      "إضافة بطاقة بنكية"
    ],
    tips: [
      "يرجى إكمال مصادقة الاسم الحقيقي قبل إضافة بطاقة بنكية",
      "يجب أن يكون اسم الحساب الموجود على بطاقتك المصرفية متوافقًا مع الاسم الحقيقي الذي قمت بمصادقته، وإلا فلن تتمكن من سحب النقود بنجاح."
    ],
    label: [
      "اسم",
	  "اسم البنك",
      "رقم الحساب البنكي",
      "رمز الفرع"
    ],
    placeholder: [
      "الرجاء تحديد اسم البنك",
      "الرجاء إدخال رقم الحساب البنكي",
      "الرجاء إدخال رمز الفرع",
	  "يتأكد",
	  "يلغي"	
    ]
  },
  wallet: {
    default: [
      "محفظتي",
      "إعادة الشحن",
      "انسحاب",
      "سجل إعادة الشحن",
      "سجل الانسحاب",
      "ر",
      "في",
      "إعادة شحن USDT"
    ],
    label: [
      "طريقة السحب",
      "مبلغ السحب",
      "كلمة مرور الصندوق",
      "يُقدِّم",
      "رقم التليفون",
      "بريد إلكتروني",
      "اي اف اس سي",
      "طريقة الدفع",
	    "الضرائب",
      "المبلغ الفعلي المستلم"
    ],
    placeholder: [
      "اختر طريقة السحب",
      "الرجاء إدخال مبلغ السحب",
      "الرجاء إدخال كلمة مرور الصندوق",
      "الرجاء تحديد طريقة السحب",
      "الرجاء إدخال رقم الهاتف المحمول للمستفيد",
      "الرجاء إدخال عنوان البريد الإلكتروني للمستفيد",
      "الرجاء إدخال المستفيد IFSC",
      "الرجاء اختيار طريقة الدفع"
    ],
    msg: [
      "لم تقم بتعيين كلمة مرور للصندوق بعد، يرجى تعيين كلمة مرور أولاً",
      "لم تقم بربط بطاقتك البنكية بعد، يرجى ربطها أولاً",
      "<p>وقت السحب: الاثنين: M9</p><p>الثلاثاء: M8</p><p>الأربعاء: M6/M7</p><p>الخميس: M3/M4/M5</p><p>الجمعة: M1/M2</p><p>(المتدربين من الاثنين إلى الأحد)</p><p>9am to 6pm</p>"
    ]
  },
  recharge: {
    default: [
      "إعادة الشحن",
      "تفاصيل إعادة الشحن",
      "سجل إعادة الشحن",
      "الرصيد المتاح {money}, الرجاء اختيار طريقة إعادة الشحن",
      "الحد الأدنى للمبلغ هو {currency} {min}, maximum {currency} {max}, رسوم المناولة {fee}%",
      "تقديم...",
      "اشحن الآن",
      "يعود",
      "تحميل...",
	  "الحد الأدنى للمبلغ هو ${min}, الحد الأقصى ${max}, رسوم المناولة {fee}%"
    ],
    label: [
      "مبلغ إعادة الشحن",
      "قناة إعادة الشحن",
      "اسم التحويل",
      "اسم الدافع",
      "الهاتف المحمول للدافع",
      "حساب UPI للدافع",
      "البريد الإلكتروني للدافع",
	    "أمر المعاملة"
    ],
    placeholder: [
      "الرجاء إدخال مبلغ إعادة الشحن",
      "الرجاء تحديد قناة إعادة الشحن",
      "الرجاء إدخال اسم التحويل",
      "الحد الأدنى للمبلغ هو {currency} {min}",
      "الحد الأقصى للمبلغ الواحد هو {currency} {max}",
      "الرجاء إدخال اسم الدافع",
      "الرجاء إدخال رقم الهاتف المحمول للدافع",
      "الرجاء إدخال حساب UPI للدافع",
      "الرجاء إدخال عنوان البريد الإلكتروني للدافع",
	  "يرجى تحميل لقطة شاشة للنقل",
	  "الرجاء إدخال رقم أمر المعاملة"
    ],
    info: [
      "مبلغ إعادة الشحن",
      "رقم الطلب",
      "بنك",
      "رقم الحساب",
      "اسم",
      "ينسخ",
      "{type} تحويل",
      "نقل لقطة الشاشة",
      "يُقدِّم",
      "رمز IFSC",
      "نوع الحساب",
      "تعليمات المعالجة"
    ],
    tips: [
      "يرجى اختيار الطريقة التالية لتحويل المبلغ المطابق لتجنب التأخير في الفحص المالي.<br>بعد النقل، يرجى تحميل لقطة الشاشة للنقل كشهادة تحقق",
      "لا حاجة لإضافة الأصدقاء، امسح رمز الاستجابة السريعة لتحويل الأموال إليّ",
      "يرجى إكمال عملية التحويل وفقًا للمعلومات أدناه",
      "تلميح: بعد الدفع الناجح، يرجى الاتصال بالخدمة عبر الإنترنت لتقديم رقم حساب العضو الخاص بك، ومبلغ إعادة الشحن، ورقم الطلب، ورقم حساب المودع، ووقت إعادة الشحن، لتسهيل قيام القسم المالي بإضافة الأموال لك في الوقت المناسب.",
      "ملحوظة: يرجى تقديم دفعة واحدة لكل تحويل",
      "بعد النقل، يرجى تحميل لقطة الشاشة للنقل كشهادة تحقق",
	    "نصيحة: بعد نجاح الدفع، يرجى تحميل صورة للمعاملة الناجحة",
      "<p>تذكير إعادة الشحن:</p><p>بعد تقديم طلب إعادة الشحن، إذا لم تتمكن من الانتقال مباشرة إلى برنامج Ccash/Maya، فيمكنك استخدام لقطة الشاشة لحفظ رمز الاستجابة السريعة في الألبوم، واستخدام رمز الاستجابة السريعة لإكمال الدفع!</p><p>(رمز الاستجابة السريعة QR صالح لعملية دفع واحدة، ويمنع حفظ رمز الاستجابة السريعة لعملية دفع ثانية)</p>"
    ],
    minPayHint: "الحد الأدنى لمبلغ الدفع هو {min}TJS"
  },
  task: {
    default: [
      "قائمة المهام",
      "متطلبات المهمة",
      "يخلق",
      "مراجعة",
      "افتح الرابط",
      "انسخ الرابط",
      "سعر الوحدة",
      "يُقدِّم",
      "التنازل",
      "ابدأ بالخدمة",
      "في تَقَدم",
      "بدء المهمة"
    ],
    tabs: [
      "عمل",
      "مراجعة",
      "مكتمل",
      "فشل",
      "الحقد",
      "متروك"
    ],
    msg: "لقد تم الانتهاء من مهمة اليوم",
    msgSc: "تم الاستلام بنجاح",
    msgTime: "بعد انتهاء العد التنازلي، سيتم إكمال المهمة تلقائيًا وسيكون إغلاقها مبكرًا غير صالح!",
    info: [
      "تفاصيل المهمة",
      "عنوان المهمة",
      "فوائد المهمة",
      "وصف المهمة",
      "متطلبات التحميل",
      "إرسال العينة",
      "لم يقدم المستخدم العينة",
      "ملاحظات التدقيق",
      "تاريخ التدقيق",
      "جانب الطلب",
      "يطلق",
      "ينسخ",
      "القفز",
      "خطوات المهمة",
      "الخطوة {index}",
      "عينة التدقيق",
      "لا يوجد عينة تدقيق",
      "تحميل البيانات...",
      "التخلي عن المهمة",
      "إرسال المهمة المكتملة",
      "نشر المحتوى"
    ],
    index: [
      "الحالة الحالية",
      "تقييمك الحالي هو <i style=\"color:#1989fa\">{currVip}</i><br>لا يمكن المطالبة إلا بالتيار الحالي <i style=\"color:#1989fa\">{currVip}</i> مهمة المستوى<br>هل تريد الانضمام؟ <i style=\"color:#dd6161\">{vip}</i> مستوى",
      "انضم الآن",
      "الرجاء تحديد فئة المهمة",
	    "يلغي",
      "متبقي",
      "بطاقة إسقاط مجانية",
      "ترقبوا"
    ],
    list: [
      "قائمة المهام",
      "جانب الطلب",
      "متبقي",
      "طلب",
      "استلام"
    ],
    show: [
      "تفاصيل المهمة",
      "وقت الشراء",
      "حالة التسليم",
      "سعر الإيجار",
      "موعد التسليم",
      "العد التنازلي للاستلام",
      "ابدأ بالخدمة",
      "الترميز",
	  "غير مخصص"
    ]
  },
  postRecord: [
    "إدارة الإصدار",
    "يطلق",
    "المجموع",
    "مكتمل",
    "موعد التسليم",
    "مراجعة",
    "إلغاء",
    "المحررين"
  ],
  dayReport: [
    "البيان اليومي",
    "إجمالي الإيرادات",
    "عمولتي",
    "فوائد عمولتي",
    "المهام التي أنجزها المرؤوسون",
    "فوائد المهام التابعة",
    "بي سي إي",
    "آخر 30 يومًا",
    "كمية",
    "مهمة",
    "تابع",
    "استهلاك",
    "تاريخ"
  ],
  fundRecord: {
    default: [
      "سجلات النفقات",
      "سجل إعادة الشحن",
      "سجلات الإيرادات",
      "ر",
      "أنا",
      "و",
	  "سجلات السحب",
    ],
    tabs: [
      "ربح",
      "النفقات",
      "إعادة الشحن",
	  "انسحاب"
    ],
	state: [
		'الجميع',
		'إعادة الشحن',	//1 recharge
		'انسحاب',	//2 withdrawal
		'نشر المهمة',	//3 task
		'مضخة بلات',	//4 pump
		'خصم',	//5 rebate
		'المهمة تم إنجازها',	//6 commission
		'مكافآت النشاط',	//7 regment
		'مكافآت الإحالة',	//8 spread
		'يرقي',	//9 buymembers
		'إلغاء المهمة',	//10 revoke
		'دخل الاستثمار',	//11 transfer_c
		'التحويل إلى الاستثمار',	//12 transfer_r
		'الإيرادات الأخرى', //13 其他
		'يتبرع',	//14
		'الظرف الأحمر',	//15
		'شراء الروبوتات الذكية',//16
		'السحب المحظوظ',//17
		'استرداد قيمة شراء LP',//18
	]
  },
  promote: [
    "صديقك المفضل",
    "ندعوك للانضمام إلى {title}",
    "رمز الإحالة",
    "نسخ رمز التوصية ",
    "انسخ رابط الدعوة",
    "احفظ رمز الاستجابة السريعة",
    "الحوافز الترويجية",
    "تم حفظ الملصق بنجاح",//7
    "فشل حفظ الملصق، يرجى المحاولة عدة مرات أخرى أو حفظ لقطة الشاشة",
    "الرجاء التقاط لقطة شاشة",
    "ملصق ترويجي للحفظ",
    "احفظ ملصق العرض الترويجي على هاتفك<br>إذا لم تنجح، فيرجى المحاولة عدة مرات أخرى أو حفظ لقطة الشاشة",
	  "فقط عندما تصبح موظفًا رسميًا على مستوى LP، تكون مؤهلاً لدعوة الأصدقاء للانضمام!",
    "يدعو",
    "<p>1. مكافأة الإحالة: سيحصل كل من يقوم بتجنيد أعضاء جدد للانضمام إلى SGM.sى مكافأة إحالة.</p><p>2. عمولة الفريق: يمكنك الحصول على عمولة من أوامر المهام الخاصة بالأعضاء المرؤوسين كل يوم.</p><p>3. أنشطة الشركة: تطلق الشركة أنشطة رعاية مختلفة من وقت لآخر، بما في ذلك السحوبات، والمظاريف الحمراء النقدية، والجوائز المادية، وغيرها من الأنشطة والفوائد.</p><p>٤. المكافأة التراكمية: عندما يصل العدد التراكمي للأصدقاء المدعوين إلى عدد معين، يمكنك الحصول على مكافأة نقدية مخصصة على الصفحة الرئيسية للمنصة. كلما زاد العدد المتراكم، زادت المكافأة.</p><p>٥. المنصب في الشركة: عندما يتطور فريقك إلى مستوى معين، يمكنك الانضمام إلى المزيد من المناصب في الشركة، مثل وظائف مبتدئ/متوسط/كبير/مساعد مدير، ويمكنك الحصول على راتب إضافي شهريًا. في SGMSGM مساحة واسعة للتطوير المهني لجميع الموظفين. يتمتع الجميع بفرص متساوية. دعونا نشهد نجاح كل عضو معًا!</p>",
    "تطوير الفريق"
  ],
  teamReport: {
    default: [
      "يبحث",
      "توازن الفريق",
      "فوائد الفريق",
      "إعادة شحن الفريق",
      "انسحاب الفريق",
      "عدد الشحنة الأولى",
      "عدد الدفعة الأولى",
      "حجم الفريق",
      "فريق جديد",
      "بي سي إي",
      "أنا",
      "مستخدم",
      "إعادة الشحن",
      "عمليات السحب",
      "خصم",
      "عمولة",
      "حدد التاريخ",
      "لا توجد بيانات",
      "مبلغ السحب",
      "رقم السحوبات",
      "خصم السحوبات",
      "عدد انسحابات الفريق",//21
      "شريك الفريق",
      "إجمالي الدخل الموصى به",
      "إجمالي الإيرادات من خصومات المهام",
      "إجمالي عمليات سحب الفريق من المستوى 3",
      "درجة",
      "الوالد",
      "المدعوين",
      "قائمة الأعضاء",
      "إجمالي الأعضاء",
      "انقر لعرض الفريق"
    ],
    tabs: [
      "تقارير الفريق",
      "فريقي"
    ],
    team: [
      "المستوى 1",
      "المستوى الثاني",
      "المستوى 3"
    ],
    totalUser: "إجمالي الأعضاء",
    clickViewTeam: "انقر لعرض الفريق"
  },
  help: [
    "دليل المساعدة",
    "غير متوفر"
  ],
  message:[
	  "عرض الرسالة",
	  "لا توجد رسالة"
  ],
  credit: [
    "درجة الائتمان",
    "مذكرة ائتمان",
    "سجلات الائتمان",
    "<p>تبلغ درجة الائتمان الأولية 60 نقطة.</p><p>1: إذا كانت النتيجة أقل من 50 نقطة، سيتم تقليص عدد المهام اليومية المكتملة إلى النصف.</p><p>2: إذا كانت النتيجة أقل من 30 نقطة، لا يمكن إكمال مهام العمل اليومية.</p><p>3: إذا كانت النتيجة أقل من 10 نقاط، لا يمكنك التقدم بطلب سحب نقدي.</p><p>قواعد مكافأة النقاط: ترقية مستوى العمل ستضيف 5 نقاط، ودعوة المرؤوسين ليصبحوا (موظفين رسميين) ستضيف نقطة واحدة.</p><p>إن اتخاذ موقف سلبي تجاه العمل، والفشل في إكمال المهام في الوقت المحدد، وانتهاك لوائح الشركة، كل ذلك من شأنه أن يؤثر على درجة الائتمان الشخصية الخاصة بك.</p>",
    "رصيدي الائتماني",
    "لا يوجد سجل ائتماني في الوقت الحالي"
  ],
  dialog: [
    "نصائح",
    "يتأكد",
    "تقديم...",
    "تمت النسخة بنجاح",
    "إصدار نظام IOS منخفض وغير مدعوم",
    "التسجيل...",
    "تحميل البيانات..."
  ],
  lineList: [
    "اختيار الخط",
    "الخط الحالي",
    "خط"
  ],
  serviceCenter: [
    "خدمة العملاء",
    "مرحبا، خدمة العملاء الحصرية",
    "يسعدني أن أخدمك.",
    "الخدمة الذاتية",
    "خدمة العملاء عبر الإنترنت",
    "خدمة عملاء إعادة الشحن",
    "خدمة العملاء عبر الخط"
  ],
  direct:[
  	  'SGM.s  	  مكافأة النمو',
  	  'وصف النشاط',
  	  '<p>بعد دعوة الأعضاء مباشرة للانضمام إلى مستوى LP، يمكنك الحصول على مكافآت نقدية إذا كنت تستوفي الشروط!</p><p>على سبيل المثال: إذا دعوتَ ثلاثة أعضاء من مستوى LP بشكل تراكمي، يمكنك استلام المكافأة مباشرةً. بعد استلامها، استمر في تحقيق أهداف أخرى واستلمها.</p><p>مكافأة النمو الحصرية لـ SGM.sيث يمكن لكل موظف استلام كل جائزة مرة واحدة فقط.</p>',
  	  'عدد المرؤوسين',
  	  'سيتم الانتهاء منه',
  	  'فوائد الدعوة',
	    'احصل على المكافآت',
      'تلقى'
  ],
  activity:[
    'صدقة',
    'تفاصيل',
    'يتبرع',
    'رصيد الحساب',
    'الجميع',
    'يدفع',
    'الرجاء إدخال مبلغ التبرع',
    'شكرا لك على تبرعك'
  ],
  apply: {
    awardsTitle: "Awards",
    awardsContent: "Awards",
    pickUpVehicles: "Pick up {count} vehicles"
  },
  positions:{
     info:[
		 'تفاصيل الوظيفة',
		 'طلب وظيفة',
		 'موضع',
		 'فريق المستوى 3 موظفون عاديون من المستوى G',
		 'نسبة أعضاء الفريق من المستوى الثالث',
		 'راتب هذا الشهر',
		  'تسوية الراتب',
		   'مكتمل',
			'سيتم الانتهاء منه',
			 'تلقى',
			 'وقت تحصيل الراتب'
			 ],
    job: [
		'تقديم للمراجعة',
		'قيد المراجعة',
		'تمت المراجعة',
		'يرجى تحميل المستندات ذات الصلة',
		'تعليقات',
		'انقر على الصورة لتحديد صورة هويتك وتحميلها. ',
		'يرجى تحميل صورة للجزء الأمامي من بطاقة الهوية الخاصة بك في الصورة أ.',
		'يرجى تحميل صورة من الجزء الخلفي لبطاقة الهوية الخاصة بك في الصورة ب.',
		'يرجى تحميل صورة لنفسك وأنت تحمل بطاقة هويتك في الصورة ج.',
		'الصورة أ',
		'الصورة ب',
		'الصورة ج',
		'الرجاء تحديد المنصب الذي تريد الترقية إليه',
		'موضع',
		'الراتب الأساسي',
		'مكافأة إضافية',
		'إشعار للموظفين',
		'لقد قرأت ووافقت على محتويات "إرشادات التقديم للوظيفة"',
		'تقديم طلب الوظيفة',
		"الرجاء تحديد المنصب",
		"الرجاء تحديد الصورة أ",
		"الرجاء تحديد الصورة ب",
		"الرجاء تحديد الصورة ج"
		]
	},
}